import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 75%;
  max-width: 400px;
  position: fixed;
  top: 10px;
  right: 10px;
  transition:
    transform 0.35s ease,
    opacity 0.35s ease;
  transform: ${({ $open }) => ($open ? "translateX(0)" : "translateX(110%)")};
  opacity: ${({ $open }) => ($open ? 1 : 0)};
`;

const CloseButton = styled.button`
  padding: 6px 10px;
  position: absolute;
  left: -40px;
  top: 0;
  border-radius: 4px;
  border: none;
  background-color: rgb(245, 245, 245);
  &:hover {
    background-color: #fff;
  }
  cursor: pointer; 
`;

const Player = () => {
  const [isOpen, setIsOpen] = React.useState(true);
  const [render, setRender] = React.useState(true);

  const handleClose = () => {
    setIsOpen(false);
    setTimeout(() => setRender(false), 350);
  };

  if (!render) return null;

  return (
    <Wrapper $open={isOpen}>
      <CloseButton onClick={handleClose}>X</CloseButton>
      <iframe
        width="100%"
        height="450"
        scrolling="no"
        frameBorder="no"
        allow="autoplay"
        src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/soundcloud%3Aplaylists%3A2224702805%3Fsecret_token%3Ds-YqF8Zb420Mk&color=%23cccccc&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
        title="SoundCloud player"
      />
    </Wrapper>
  );
};

export default Player;
